import { memo, type FC } from 'react';

import {
  TableCardHeaderActionWrapper,
  TableCardHeaderTabsContainer,
  TableCardHeaderTitleWrapper,
  TableCardHeaderWrapper,
} from './styled.ts';
import type { TableCardHeaderProps } from './types.ts';

export const TableCardHeader: FC<TableCardHeaderProps> = memo(function TableCardHeader({ className, title, action, tabs, dataTestId }) {
  return (
    <>
      {(title || action) && (
        <TableCardHeaderWrapper className={className}>
          <TableCardHeaderTitleWrapper data-testid={dataTestId}>
            {title || <div />}
            {action && <TableCardHeaderActionWrapper>{action}</TableCardHeaderActionWrapper>}
          </TableCardHeaderTitleWrapper>
        </TableCardHeaderWrapper>
      )}
      {tabs && <TableCardHeaderTabsContainer>{tabs}</TableCardHeaderTabsContainer>}
    </>
  );
});
